import { MediaMatcher } from '@angular/cdk/layout';
import { MensagemSucessoComponent } from './../modal/mensagem-sucesso/mensagem-sucesso.component';
import { MensagemAvisoComponent } from './../modal/mensagem-aviso/mensagem-aviso.component';
import { MensagemErroComponent } from './../modal/mensagem-erro/mensagem-erro.component';
import { MatDialog } from '@angular/material';
import { ConsumirApiService } from './../consumir-api.service';
import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { RecaptchaComponent } from 'ng-recaptcha';
import { jsPDF } from 'jspdf';

@Component({
  selector: 'app-login-teste',
  templateUrl: './login-teste.component.html',
  styleUrls: ['./login-teste.component.css'],

})
export class LoginTesteComponent implements OnInit, OnDestroy {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  codigo_autenticidade = '';
  nome_servidor = 'Pedro da Silva Azevedo';
  cpf = '052.896.653-74';
  rg = '032646122007-5';

  constructor(
    private _rotas: Router,
    private _api: ConsumirApiService,
    private _dialog: MatDialog,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher) {
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  teste() {
    const doc = new jsPDF({ format: 'a4', orientation: 'p' });
    // tslint:disable-next-line: max-line-length
    // const brasao = new Image().src = 'assets/images/brasao.jpg';
    // const arquivo = new File(['./assets/images/brasao.jpg'], 'brasao.jpg');

    // const reader = new FileReader();

    // reader.readAsDataURL(arquivo);

    doc.addImage('./assets/images/brasao.jpg', 'JPEG', 95, 10, 20, 20);

    doc.setFontSize(12);
    doc.text('GOVERNO DO ESTADO', 80, 35);
    doc.text('INSTITUTO DE PREVIDÊNCIA DOS SERVIDORES DO ESTADO - IPREV', 35, 40);
    doc.text('DIRETORIA DE PAGAMENTO DE BENEFÍCIOS PREVIDENCIARIOS', 40, 45);
    doc.text('COORDENADORIA DE PAGAMENTO DE PENSIONISTAS', 55, 50);

    doc.rect(100, 80, 90, 30);
    doc.setFontSize(10);
    doc.text('CNPJ: 03.110.907/0001-00', 125, 85);
    doc.text('Fundo Estadual de Pensão e Aposentadoria - FEPA', 103, 90);
    doc.text('Av. dos Holandeses, nº01, Ed. Biadene Home Office', 103, 95);
    doc.text('13º andar - Ponta do Farol.', 103, 100);
    doc.text('CEP: 65.077-635, São Luís - MA', 103, 105);

    doc.setFontSize(12);
    doc.text('Sr.(a) gerente', 20, 120);
    doc.text('BANDO DO BRASIL S/A', 20, 125);

    doc.text('\t\t\t\t\tSolicitamos providências de Vossa Senhoria quanto à abertura de ',
      20,
      140,
      { align: 'justify' });

    doc.text('conta corrente nessa Instituição Financeira tendo como ' +
      `titular o(a) senhor(a) ${this.nome_servidor}, ` +
      `CPF ${this.cpf}, Identidade ${this.rg} para crédito ` +
      'referente à Pensão Previdênciária a ser custada pelo Fundo Estadual de Pensão e ' +
      'Aposentadoria do Estado do Maranhão - FEPA, gerido por este Instituto de Previdência.',
      20,
      148,
      { align: 'justify', maxWidth: 170, lineHeightFactor: 2 });

    doc.text('São Luís (MA), 13 de Setembro de 2020', 110, 200);

    doc.addImage('./assets/images/assinatura.png', 'PNG', 80, 220, 60, 40);

    doc.save('Abertura de Conta Corrente BB.pdf');
  }

  resolved(captchaResponse: string) {
  //console.log(`Resolved captcha with response: ${captchaResponse}`);
    if (this.codigo_autenticidade.length > 0) {

      this._api.validarAutenticidade(this.codigo_autenticidade).subscribe(
        data => {
          //console.log(data[0].situacao_id)
          //console.log(data[0].instituidor.solicitante.nome_solicitante);

          if (data.length > 0) {
            const nome_solicitante = data[0].solicitante_imobiliario.nome_solicitante;
            const observacao = data[0].observacao;
            const numero_processo = data[0].numero_processo;
            if (data[0].situacao_id === 2) {
              const modal = this._dialog.open(MensagemErroComponent, {
                data:
                {
                  titulo: 'Documentação Recusada!',
                  mensagem: `<p>${nome_solicitante}, segue abaixo informações do analista:</p>
                             <p>${this.validarMensagem(observacao)}</p>
                             <p>Por favor, verifique o que está incorreto e abra uma nova solicitação.</p>`},
                hasBackdrop: true,
                disableClose: true
              });

              modal.afterClosed().subscribe(() => {
                this.codigo_autenticidade = '';
                grecaptcha.reset();
              });
            } else if (data[0].situacao_id === 3) {
              const modal = this._dialog.open(MensagemSucessoComponent, {
                data:
                {
                  titulo: 'Documentação Aprovada!',
                  mensagem: `<p>${nome_solicitante}, Sua documentação foi analisada e aprovada pela COGIM!.</p>
                  <p>Em breve sua certidão será enviada por e-mail:</p>
                  `},
                hasBackdrop: true,
                disableClose: true
              });

              modal.afterClosed().subscribe(() => {
                this.codigo_autenticidade = '';
                grecaptcha.reset();
              });
            } else {
              const modal = this._dialog.open(MensagemAvisoComponent, {
                data:
                {
                  titulo: 'Aguardando Análise!',
                  mensagem: `<p>${nome_solicitante}, por favor aguarde a análise da sua solicitação pelo setor de Gestão Imobiliária do IPREV.</p>
                            <p>Após a análise, você será informado via e-mail sobre o resultado.</p>`},
                hasBackdrop: true,
                disableClose: true
              });

              modal.afterClosed().subscribe(() => {
                this.codigo_autenticidade = '';
                grecaptcha.reset();
              });
            }
          } else {
            const modal = this._dialog.open(MensagemErroComponent, {
              data:
              {
                titulo: 'Código de Autenticidade Inválido!',
                mensagem: `<p>Por favor, digite um código válido.</p>`
              },
              hasBackdrop: true,
              disableClose: true
            });

            modal.afterClosed().subscribe(() => {
              this.codigo_autenticidade = '';
              grecaptcha.reset();
            });
          }
        }
      );

    } else {
      grecaptcha.reset();
      this._dialog.open(MensagemErroComponent, {
        data:
          { titulo: 'Preencha o campo Código de validação!' },
        hasBackdrop: true,
        disableClose: true
      });
    }
  }

  solicitarRevisao() {
    this._rotas.navigate(['solicitacao']);
  }

  validarMensagem(texto: string) {

    const removendo_nulo = texto.replace(/null/g, ''); // expressão regular para verificar todas as ocorrencias de null na string.
    const removendo_object = removendo_nulo.replace(/\[object Object\]/g, '');
    const texto_formatado = removendo_object.replace(/\,/g, '');
    // expressão regular para verificar todas as ocorrencias de null na string.

    if (texto_formatado.trim().length > 0) {
      return texto_formatado.trim();
    }

    return 'Nenhuma mensagem registrada pelo analista.';
  }

}
